import { useFormContext } from 'react-hook-form';
import { CopyAssistButtonDropdown } from 'modules/ai/copyAssist/CopyAssistButtonDropdown';
import { CopyAssistTagNames } from 'modules/domains/copyAssist/copyAssist';
import { dataTestId as dataTest } from 'modules/experiments/constants';
import { useCopyAssistContext } from 'modules/experiments/contexts';
import { CopyAssistTextFormFieldProps } from 'modules/experiments/types';
import { StyledVariantTextAreaFormField } from 'modules/experiments/components/pages/edit/sections/variant_configuration/CommonStyled';
import { TextAreaField } from 'lib/iterable-hook-form';
import { useSchemaValidationErrorTranslations } from 'utils/hooks/useTranslation';
import { ReadOnlyValue } from '../ReadOnlyValue';
import { StyledCopyAssistWrapper } from './Styled';

export const CopyAssistTextAreaWithErrorContext = ({
  dataTestId,
  dataKey,
  isFieldEditable,
  isFieldFocused = false,
  fieldLabel,
  fieldName,
  fieldValue,
  fieldTemplateErrors,
  helperText,
  contentType,
  messageMedium,
}: CopyAssistTextFormFieldProps) => {
  const { zt } = useSchemaValidationErrorTranslations();
  const {
    formState: { errors },
    getValues,
    setValue,
  } = useFormContext();
  const {
    activateCopyAssist,
    activatedFormField,
    copyAssistFormState = {},
  } = useCopyAssistContext();

  const errorKey = errors[fieldName]?.message?.toString() ?? '';
  const errorText = zt(errorKey) || fieldTemplateErrors;
  const hasError = !!errors[fieldName] || !!fieldTemplateErrors?.length;

  return (
    <StyledVariantTextAreaFormField
      data-test={`${dataTest.copyAssistField}-${dataTestId}`}
      ref={copyAssistFormState?.[dataKey]?.formFieldWrapperRef}
      labelText={fieldLabel}
      hasError={hasError}
      errorText={errorText}
      helpText={isFieldEditable ? helperText : null}
      isHorizontalLayout
    >
      {isFieldEditable ? (
        <StyledCopyAssistWrapper>
          <TextAreaField
            textAreaWrapperRef={copyAssistFormState?.[dataKey]?.formFieldRef}
            name={fieldName}
            onFocus={() => activateCopyAssist(fieldName, dataKey)}
            autoFocus={isFieldFocused}
          />
          {activatedFormField === fieldName && (
            <CopyAssistButtonDropdown
              contentType={contentType}
              targetRef={copyAssistFormState?.[dataKey]?.formFieldRef}
              targetTagName={CopyAssistTagNames.Input}
              fieldName={fieldName}
              value={getValues(fieldName)}
              setField={setValue}
              messageMedium={messageMedium}
              addSuggestionsAsVariants
            />
          )}
        </StyledCopyAssistWrapper>
      ) : (
        <ReadOnlyValue>{fieldValue}</ReadOnlyValue>
      )}
    </StyledVariantTextAreaFormField>
  );
};
